import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { type UserState } from './store.type';
import { UserRole } from '../utils/userType';

export const initialUserState: UserState = {
  displayName: '',
  preferredLanguage: '',
  role: UserRole.UNAUTHORIZED,
};

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    initUser: (state, action: PayloadAction<UserState>) => {
      state.displayName = action.payload.displayName;
      state.preferredLanguage = action.payload.preferredLanguage;
      state.role = action.payload.role;
    },
    updateLanguage: (state, action: PayloadAction<string>) => {
      state.preferredLanguage = action.payload;
    },
  },
});

export const { initUser, updateLanguage } = userSlice.actions;

export default userSlice.reducer;
